import React from 'react'
import { Typography } from 'antd';
import TableWorkers from './TableWorkers';
import TableExpenses from './TableExpenses';
import TableSubscr from './TableSubscr';
import TableErrors from './TableErrors';
import TableAvgTime from './TableAvgTime';
import './styles.scss';

const EngineStatus = () => {

  return (
    <>
      <Typography.Title>Engine Status</Typography.Title>
        <TableWorkers />
        <div className='JobStatus'>
        <TableExpenses />
        <TableErrors />
        <TableAvgTime />
        <TableSubscr />
        </div>
    </>
  )
}

export default EngineStatus
